const RFC_VALIDATION_REGEX = /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/;

const PERSON = 'person';
const COMPANY = 'company';
const GENERIC = 'generic';
const GENERIC_FOREIGN = 'genericForeign';

const GENERIC_RFC = 'XAXX010101000';
const GENERIC_FOREIGN_RFC = 'XEXX010101000';

export const rfcTypes = {
  PERSON,
  COMPANY,
  GENERIC,
  GENERIC_FOREIGN,
} as const;

/**
 * Validates a Mexican tax ID (RFC) and determines its type.
 *
 * @param taxId - RFC string to validate
 * @param includeGenericRfc - Whether to distinguish generic RFC values
 * @returns Object with isValid flag and detected type
 */
export const validateTaxId = (taxId?: string, includeGenericRfc = false) => {
  const type = (() => {
    if (taxId?.length === 12) return COMPANY;
    if (taxId?.length === 13) {
      if (!includeGenericRfc) return PERSON;
      if (taxId === GENERIC_RFC) return GENERIC;
      if (taxId === GENERIC_FOREIGN_RFC) return GENERIC_FOREIGN;
      return PERSON;
    }
    return null;
  })();

  return { isValid: taxId?.match(RFC_VALIDATION_REGEX) !== null, type };
};

const COMMERCIAL_SOCIETIES = [
  'S. en N.C.',
  'S. en N.C. de C.V.',
  'S. de R.L. de C.V.',
  'S.A. de C.V.',
  'S.A de C.V',
  'S. en C. por A',
  'S.C.L',
  'S.C.S.',
  'S.A.S.',
  'S.A.P.I.',
];

/**
 * Checks if a business name contains a commercial society suffix and returns the match.
 *
 * @param str - Business name string to check
 * @returns Object with isMatch flag and the matched word to replace
 */
export const matchSocietyRegime = (str = '') => {
  const result = { isMatch: false, replaceWord: '' };

  if (!str) return result;

  const withoutDots = COMMERCIAL_SOCIETIES.map((cs) => {
    const reduced = cs.replaceAll('.', '');
    return reduced === 'SAS' ? cs : reduced;
  });

  const toMatch = [...COMMERCIAL_SOCIETIES, ...withoutDots].map((word) => word.toUpperCase());

  for (let i = 0; i < toMatch.length; i += 1) {
    const escaped = toMatch[i].replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const wordToMatch = new RegExp(escaped, 'g');

    if (str.match(wordToMatch)) {
      result.isMatch = true;
      result.replaceWord = toMatch[i];
      break;
    }
  }

  return result;
};
